export default (host) => {
  let reqHost = host;
  if (host.indexOf('www.') === 0) {
    reqHost = host.substring(4);
  }

  const [address] = reqHost.split(':'); // omit port (like hotel.hcommerce.com:3000)

  if (address.indexOf(process.env.BASE_DOMAIN_URL) > 0) {
    return address.split('.')[0];
  }
  return address;
};
